<template>
    <section class="step-3">

        <!-- les informations du voyageur -->

        <ul class="ariane">
            <li class="item">{{ roomLabelCap }} {{ cabinIndex + 1 }}</li>
            <li class="item">Voyageur {{ travelerIndex + 1 }}</li>
            <li class="item active">Informations</li>
        </ul>

        <form @submit.prevent="nextTraveler">
            <div>
                <custom-select v-model="traveler.title"
                               :options="titleOptions"
                               value-field="value"
                               class="civility-select"
                               required>
                </custom-select>
            </div>
            <div class="wrap-input">

                <floating-label label="Nom *" for="last-name">
                    <input type="text"
                           id="last-name"
                           v-model="traveler.lastName"
                           required
                           autocomplete="family-name">
                </floating-label>

                <floating-label label="Prénom *" for="first-name">
                    <input type="text"
                           id="first-name"
                           v-model="traveler.firstName"
                           required
                           autocomplete="given-name">
                </floating-label>

                <floating-label label="Email *" for="email">
                    <input type="email"
                           id="email"
                           v-model="traveler.email"
                           required
                           autocomplete="email">
                </floating-label>

                <floating-label label="Date de naissance *" for="birth-date">
                    <input type="text"
                           id="birth-date"
                           v-model="traveler.birthDate"
                           v-mask="'##/##/####'"
                           required
                           autocomplete="birthdate">
                </floating-label>

                <floating-label :label="`Numéro de passeport${passportRequired ? ' *' : ''}`" for="passport-id"
                                v-if="passportRequired">
                    <input type="text"
                           id="passport-id"
                           v-model="traveler.passportId"
                           :required="passportRequired">
                </floating-label>

                <floating-label :label="labelPassportRequired" for="passport-validity-date" v-if="passportRequired">
                    <input type="text"
                           id="passport-validity-date"
                           v-model="traveler.passportValidityDate"
                           v-mask="'##/##/####'"
                           required
                           autocomplete="passport-validity-date">
                </floating-label>

                <floating-label label="Informations complémentaires" class="textarea infos" for="additional-infos">
                    <textarea id="additional-infos" v-model="traveler.additionalInfos"></textarea>
                </floating-label>
                <span class="requis">* requis</span>

            </div>


            <!-- Les options/extensions -->


            <ul class="ariane" v-if="addons.length">
                <li class="item">{{ roomLabelCap }} {{ cabinIndex + 1 }}</li>
                <li class="item">Voyageur {{ travelerIndex + 1 }}</li>
                <li class="item active">Extension</li>
            </ul>

            <article v-for="addon in addons">
                <div class="nom-item">{{ addon.label }}</div>
                <div class="valeur">
                    <p>{{addon.price | currency}}</p>
                </div>
                <div class="choix">
                    <input type="checkbox"
                           class="ge"
                           :id="`addon_${addon.id}`"
                           v-model="traveler.addons"
                           :value="addon.id">
                    <label :for="`addon_${addon.id}`">
                        Choisir
                    </label>
                </div>
            </article>


            <!-- Les assurances -->


            <ul class="ariane" v-if="insurances.length">
                <li class="item">{{ roomLabelCap }} {{ cabinIndex + 1 }}</li>
                <li class="item">Voyageur {{ travelerIndex + 1 }}</li>
                <li class="item active">Assurances disponibles</li>
            </ul>

            <article v-for="insurance in insurances">
                <div class="nom-item">{{ insurance.label }}</div>
                <div class="valeur">
                    <p>{{insurance.price}} %</p>
                </div>
                <div class="choix">
                    <input type="radio"
                           class="ge"
                           :id="`insurance_${insurance.id}`"
                           name="insurance"
                           v-model="traveler.insurance"
                           :value="insurance.id">
                    <label :for="`insurance_${insurance.id}`"
                           @click="checkInsuranceSelfSelect(insurance.id)">Choisir</label>
                </div>
            </article>
            <p class="pdf-assurance" v-if="insurances.length"><a :href="assurance_dip" target="_blank">Document d'information produit de l'assurance</a> - <a :href="assurance_cgv" target="_blank">Conditions générales de vente de l'assurance
            </a></p>

            <!-- Options supplémentaires -->

            <ul class="ariane" v-if="options.length">
                <li class="item">{{ roomLabelCap }} {{ cabinIndex + 1 }}</li>
                <li class="item">Voyageur {{ travelerIndex + 1 }}</li>
                <li class="item active">Options supplémentaires</li>
            </ul>

            <article v-for="option in options">
                <div class="nom-item">{{ option.label }}</div>
                <div class="valeur">
                    <p>{{option.price | currency}}</p>
                </div>
                <div class="choix">
                    <input type="checkbox"
                           class="ge"
                           :id="`option_${option.id}`"
                           v-model="traveler.options"
                           :value="option.id">
                    <label :for="`option_${option.id}`">
                        Choisir
                    </label>
                </div>
            </article>


            <!-- Option Geneve -->
            <template v-if="selectedDate.option_geneve">

                <ul class="ariane">
                    <li class="item">{{ roomLabelCap }} {{ cabinIndex + 1 }}</li>
                    <li class="item">Voyageur {{ travelerIndex + 1 }}</li>
                    <li class="item active">Départ depuis Genève</li>
                </ul>

                <article>
                    <div class="nom-item">Départ individuel</div>
                    <div class="valeur">
                        <p>{{selectedDate.option_geneve_solo_price | currency}}</p>
                    </div>
                    <div class="choix">
                        <input type="radio"
                               class="ge"
                               id="depart_solo"
                               name="geneve"
                               v-model="traveler.geneve"
                               value="solo">
                        <label for="depart_solo" @click="checkGeneveSelfSelect('solo')">
                            Choisir
                        </label>
                    </div>
                </article>

                <article>
                    <div class="nom-item">Départ double</div>
                    <div class="valeur">
                        <p>{{selectedDate.option_geneve_duo_price | currency}}</p>
                    </div>
                    <div class="choix">
                        <input type="radio"
                               class="ge"
                               id="depart_duo"
                               name="geneve"
                               v-model="traveler.geneve"
                               value="duo">
                        <label for="depart_duo" @click="checkGeneveSelfSelect('duo')">
                            Choisir
                        </label>
                    </div>
                </article>
            </template>

            <!-- Submit -->
            <p class="errors" v-html="error" v-if="error"></p>

            <button type="submit" class="btn chevron">
                Valider {{ roomLabelCap }} {{ cabinIndex + 1 }} Voyageur {{ travelerIndex + 1 }}
            </button>
        </form>

    </section>
</template>

<script>
    import {DateTime} from 'luxon';

    export default {
        props: {
            minPassportValidityDate: {
                type: String,
                required: true,
            },
            cruiseEndDate: {
                type: String,
                required: true,
            },
            cabinIndex: {
                type: Number,
                required: true,
            },
            travelerIndex: {
                type: Number,
                required: true,
            },
            addons: {
                type: Array,
                default: () => [],
            },
            insurances: {
                type: Array,
                default: () => [],
            },
            options: {
                type: Array,
                default: () => [],
            },
            isCircuit: {
                type: Boolean,
                default: false,
            },
            passportRequired: {
                type: Boolean,
                default: false,
            },
            selectedDate: {
                type: Object,
                required: true,
            },
            form: {
                type: Object,
                required: true,
            },
            allTravelers: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                maxBirthdayDate: DateTime.local().toISODate(),
                titleOptions: [
                    {
                        label: 'Civilité *',
                        value: '',
                    },
                    {
                        label: 'Madame',
                        value: 'mrs',
                    },
                    {
                        label: 'Monsieur',
                        value: 'mr',
                    },
                ],
                traveler: {
                    title: '',
                    addons: [],
                    options: [],
                    insurance: null,
                    geneve: null,
                    ...this.getLoggedInUserInfo(),
                },
                error: null,
                disabledBirthDates: {
                    from: DateTime.local().minus({days: 1}).toJSDate(), // Disable all dates after specific date
                },
                disabledPassDates: {
                    to: DateTime.fromISO(this.minPassportValidityDate).toJSDate(), // Disable all dates after specific date
                }
            };
        },
        computed: {
            roomLabelCap() {
                return this.isCircuit ? 'Chambre' : 'Cabine';
            },
            labelPassportRequired() {
                return `Date de validité${this.passportRequired ? ' *' : ''}`;
            },
            assurance_dip(){
                return window.GrandsEspaces.assurance_dip
            },
            assurance_cgv(){
                return window.GrandsEspaces.assurance_cgv
            }
        },
        methods: {
            getLoggedInUserInfo() {
                if (!this.$root.user || this.cabinIndex !== 0 || this.travelerIndex !== 0) {
                    return {};
                }

                return {
                    firstName: this.$root.user.firstName,
                    lastName: this.$root.user.lastName,
                    email: this.$root.user.email,
                };
            },
            nextTraveler() {

                let dt_now = DateTime.local();
                let dt_birth = DateTime.fromFormat(this.traveler.birthDate, "dd/MM/yyyy");
                let dt_pass = this.passportRequired ? DateTime.fromFormat(this.traveler.passportValidityDate, "dd/MM/yyyy") : null;
                let dt_pass_limit = this.passportRequired ? DateTime.fromISO(this.minPassportValidityDate) : null;
                let dt_pass_limit_formated = this.passportRequired ? dt_pass_limit.toLocaleString(DateTime.DATE_FULL) : null;

                if (!dt_birth.isValid) {
                    alert("La date de naissance doit être valide : JJ/MM/AAAA");
                    return;
                }

                if (dt_birth >= dt_now) {
                    alert("La date de naissance doit être antérieure à aujourd'hui.");
                    return;
                }

                if (this.passportRequired && !dt_pass.isValid) {
                    alert("La date de validité du passeport doit être valide : JJ/MM/AAAA");
                    return;
                }

                if (this.passportRequired && dt_pass < dt_pass_limit) {
                    alert("La date de validité du passeport doit être supérieure au " + dt_pass_limit_formated);
                    return;
                }


                if (this.traveler.birthDate === undefined) {
                    this.error = "La date de naissance est obligatoire.";
                    return;
                } else {
                    this.error = null;
                }

                if (this.passportRequired && this.traveler.passportValidityDate === undefined) {
                    this.error = "La date de validité du passeport est obligatoire.";
                    return;
                } else {
                    this.error = null;
                }


                this.$emit('completed', this.traveler);
            },
            checkInsuranceSelfSelect(insuranceId) {
                if (this.traveler.insurance === insuranceId) {
                    this.$nextTick(function () {
                        this.traveler.insurance = null;
                    });
                }
            },
            checkGeneveSelfSelect(value) {
                if (this.traveler.geneve === value) {
                    this.$nextTick(function () {
                        this.traveler.geneve = null;
                    });
                }
            },
        },
        activated() {
            this.$emit('clean-travelers');

        }


    };
</script>



// WEBPACK FOOTER //
// assets/js/components/cruise-configurator/TravelerInfo.vue